import classNames from 'classnames';
import {autobind} from 'core-decorators';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import styles from './styles.css';

@autobind
export default class FileInput extends Component {
    static propTypes = {
        multiple: PropTypes.bool,
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
    };

    static defaultProps = {
        multiple: false,
    };

    state = {
        files: [],
        hover: false,
    };

    handleHover(hover) {
        return () => this.setState({hover});
    }

    handleRemoveFile(index) {
        return () => {
            const files = this.state.files.reduce((updateds, file, fileIndex) => {
                if (fileIndex !== index) updateds.push(file);
                return updateds;
            }, []);

            this.setState({files});

            if (this.props.onChange) this.props.onChange(files);
            if (this.props.onBlur) this.props.onBlur();
            this.fileInput.value = '';
        };
    }

    handleChange(event) {
        const files = [...this.state.files, ...event.target.files];
        if (this.props.onChange) this.props.onChange(files);
        this.setState({files});
        if (this.props.onBlur) this.props.onBlur();
    }

    render() {
        return (
            <div className={styles.root}>
                {this.state.files.length > 0 && !this.props.disabled && (
                    <ul className={styles.list}>
                        {this.state.files.map((file, index) => (
                            <li key={file && file.name} className={styles.file}>
                                {file && file.name}
                                <div className={styles.remove} onClick={this.handleRemoveFile(index)}>
                                    <i className='material-icons'>clear</i>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
                <div
                    onMouseEnter={this.handleHover(true)}
                    onMouseLeave={this.handleHover(false)}
                    className={classNames(styles.input, {
                        [styles.disabled]: this.props.disabled,
                        [styles.hover]: this.state.hover,
                    })}>
                    <div className={styles.browse}>
                        {this.props.multiple ? 'Seleccionar archivos' : 'Seleccionar archivo'}
                    </div>
                    <input
                        ref={(ref) => (this.fileInput = ref)}
                        type='file'
                        multiple={this.props.multiple}
                        className={styles.root}
                        disabled={this.props.disabled}
                        onChange={this.handleChange}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/forms/file-input/index.js